module.exports = __webpack_public_path__ + "img/orbis-frontview.efa38110.png";